import AXIOS from "./axios";

// Convites de clínica e clínicas do médico logado (painel do médico).
export class DoctorClinics {
  static invitations() {
    return AXIOS.get("admin/clinic_invitations");
  }

  static accept(id) {
    return AXIOS.post(`admin/clinic_invitations/${id}/accept`);
  }

  static decline(id) {
    return AXIOS.post(`admin/clinic_invitations/${id}/decline`);
  }

  static clinics() {
    return AXIOS.get("admin/clinics");
  }
}

export default DoctorClinics;
